import { useCallback, useEffect } from 'react';

import { authService } from 'auth/services';

import { useIsAuthenticated } from '@azure/msal-react';

export const useLivePersonChatActivityObserver = (): void => {
  const isAuthenticated = useIsAuthenticated();

  const refreshHandler = useCallback((): void => {
    isAuthenticated && authService.throttledRefreshToken();
  }, [isAuthenticated]);
  const addEventListeners = (element: HTMLDivElement): void => {
    const options = { capture: true };

    element.addEventListener('click', refreshHandler, options);
    element.addEventListener('keydown', refreshHandler, options);
  };

  const removeEventListeners = (element: HTMLDivElement): void => {
    element.removeEventListener('click', refreshHandler);
    element.removeEventListener('keydown', refreshHandler);
  };

  useEffect(() => {
    if (isAuthenticated) {
      const config = { childList: true };

      const callback = (mutationsList) => {
        mutationsList.forEach((mutation) => {
          const { addedNodes, removedNodes } = mutation;
          const [element] = [...addedNodes, ...removedNodes];

          if (element.classList?.value.indexOf('lp_desktop') !== -1) {
            refreshHandler();
            addedNodes.length ? addEventListeners(element) : removeEventListeners(element);
          }
        });
      };

      const observer = new MutationObserver(callback);
      observer.observe(document.body, config);
    }
  }, [isAuthenticated]);
};
